import { useCallback, useMemo } from "react";
import ServiceLocator from "../../../../../domain/service-locator";
import { DetailedTour } from "../../components/tour/expandable-tour-card";
import {
  ExpandableAreaCard,
  DetailedArea,
} from "../../components/card/expandable-area-card";
import { MinpakuHeader } from "../../components/header/minpaku.header";
import { QuestionnaireCard } from "../../components/questionnaire/questionnaire-card";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";

export const MinpakuTourPageNestSample = () => {
  const localizedEntityRepository = ServiceLocator.LocalizedEntityRepository;
  const guidePlayerModule = ServiceLocator.GuidePlayerModule;
  const playerLayoutModule = ServiceLocator.PlayerLayoutModule;
  const entities = localizedEntityRepository.entities.watch();

  const currentTrack = guidePlayerModule.currentTrack.watch();

  const currentAreas = useMemo<DetailedArea[]>(
    () =>
      entities.areas
        .filter((area) => !area.isDefault) // デフォルトエリアを除外
        .map((area) => {
          const areaTours = entities.tours.filter(
            (tour) => tour.areaId === area.id
          );
          const detailedTours: DetailedTour[] = areaTours.map((tour) => ({
            ...tour,
            guides: entities.guides.filter((guide) => guide.tourId === tour.id),
          }));

          return {
            ...area,
            tours: detailedTours,
          };
        }),
    [entities]
  );

  const handleClickGuide = useCallback(
    (id: string) => {
      const shouldShowPlayer = guidePlayerModule.currentTrack.value === null;
      guidePlayerModule.select(id);
      if (shouldShowPlayer) playerLayoutModule.playerType.setValue("full");
    },
    [guidePlayerModule, playerLayoutModule.playerType]
  );

  const maxAreaNameLines = useMemo(
    () => Math.max(...currentAreas.map((a) => a.name.split("\n").length), 1),
    [currentAreas]
  );

  return (
    <AnimatedPageTransition>
      <div className="overflow-y-scroll hidden-scrollbar w-full h-full">
        <div className={"fixed top-0 left-0 w-full h-full bg-white -z-10"} />
        <div className="px-8 py-4 min-h-full">
          <MinpakuHeader />
          <div className={`flex flex-col gap-6 mb-28 pt-4`}>
            {currentAreas.map((area, index) => (
              <div key={`area-card-${area.id}`}>
                <ExpandableAreaCard
                  area={area}
                  colorIndex={index}
                  blockLabel={String.fromCharCode(65 + index)}
                  onClickGuide={handleClickGuide}
                  currentPlayingGuideId={currentTrack?.id}
                  maxAreaNameLines={maxAreaNameLines}
                />
              </div>
            ))}
            <div>
              <QuestionnaireCard />
            </div>
          </div>
        </div>
      </div>
    </AnimatedPageTransition>
  );
};
